// @ts-nocheck
import { defineComponent, computed } from 'vue';
import type { PropType } from 'vue';
import type { SVGJson, TreeObj } from '../utils/use-render';
import { renderFn, formatColor } from '../utils/use-render';
import { useNamespace } from '@nio-fe/shared';
import '../style/index.scss';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"#929398","d":"M4.96 2a.9.9 0 00-.67.3C4.1 2.5 4 2.75 4 3v18c0 .25.1.52.29.7.19.2.43.3.67.3h14.08c.24 0 .5-.1.67-.3A1 1 0 0020 21V7.5L14.5 2H4.96z"}},{"tag":"path","attrs":{"fill":"#fff","d":"M9.25 11.9c0-.83.25-1.5.71-2.04A2.7 2.7 0 0112.1 9c.83 0 1.47.23 1.96.69.45.42.69 1 .69 1.75 0 .52-.16 1-.49 1.43l-.08.09-.11.12-.24.23-.33.3-.41.37c-.23.22-.4.42-.53.63-.18.3-.27.62-.28.97h-.72a2.4 2.4 0 01.23-.96c.19-.4.59-.87 1.2-1.39l.37-.37.17-.18.07-.08c.29-.36.44-.74.44-1.14 0-.55-.17-1-.5-1.35-.36-.35-.86-.5-1.48-.5-.7 0-1.25.22-1.63.71-.2.24-.32.53-.4.87v.02c-.08.39-.39.7-.78.7zM11.48 16.55a.62.62 0 01.45-.17c.2 0 .34.06.44.16l.01.01c.12.1.18.25.18.43 0 .16-.06.3-.18.43a.65.65 0 01-.45.17.64.64 0 01-.45-.18.54.54 0 01-.17-.42c0-.2.06-.33.16-.42z"}},{"tag":"path","attrs":{"fill":"#F4F5F7","d":"M20 7.5h-4.47a1 1 0 01-.72-.3.98.98 0 01-.31-.73V2L20 7.5z","opacity":0.5}}]};

export default defineComponent({
  name: 'IconUnknownFilledLight',
  props: {
    color: {
      type: [Array, String] as PropType<string[] | string>,
      required: false,
      default: () => [],
    },
    spin: {
      type: String as PropType<'cw' | 'ccw'>,
      required: false,
    },
    size: {
      type: [String, Number],
      required: false,
      // default: 24,
    },
    rotate: {
      type: Number,
      required: false,
    },
  },
  emits: {
    click: (evt: MouseEvent) => evt instanceof MouseEvent,
  },
  setup(props, { attrs, emit }) {
    return () => {
      const { size, color, spin, rotate } = props;
      const prefix = `${useNamespace()}-icon`.toLowerCase();

      const spinClassName = `${spin ? `${prefix}_spin-${spin}` : ''}`;
      const iconStyle = computed(() => ({
        fontSize: size,
        transform: `rotate(${rotate}deg)`,
        ...(attrs.style as StyleSheet),
      }));
      const finalColor = computed(() => formatColor(color));
      const finalClass = computed(() => [prefix, `${prefix}__unknown_filled_light`, spinClassName, attrs.class]);
      const finalProps = {
        class: finalClass.value,
        style: iconStyle.value,
        onClick: (evt: MouseEvent) => emit('click', evt),
      };

      return renderFn(element, finalProps, finalColor.value as TreeObj);
    };
  },
});
